import React from "react";
import { ModalProps } from "antd/lib/modal";
import { observer, useLocalObservable } from "mobx-react";
import { ModalOptions } from "./ModalOptions";
import { Modal } from "antd";
import _ from "lodash";
import "./FullscreenModal.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinimize, faSquare, faXmark } from "@fortawesome/free-solid-svg-icons";

interface FullscreenProps extends ModalProps {
  content?: any;
  onFullscreen?: any;
  onClose?: any;
  controller?: any;
}

const FullscreenModal: React.FC<FullscreenProps> = observer(
  ({ content, onFullscreen, onClose, controller, ...restProps }) => {
    const state = useLocalObservable(() => ({
      fullscreen: false,

      setShowCancelConfirmation(state: boolean) {
        this.fullscreen = state;
      },
    }));

    const renderTitle = () => {
      return (
        <div style={{ display: "inline" }} className="modal-title">
          {restProps.title}
          {renderIcons()}
        </div>
      );
    };

    const handleFullscreenClick = () => {
      state.fullscreen = !state.fullscreen;
      onFullscreen && onFullscreen(state.fullscreen);
    };

    const renderIcons = () => {
      return (
        <div style={{ display: "inline", float: "right" }} className="fullscreen-modal-icons-container">
          <div className="flex">
            {controller && <ModalOptions controller={controller} />}

            <FontAwesomeIcon
              icon={state.fullscreen ? faMinimize : faSquare}
              data-e2e="modal-fullscreen-icon"
              onClick={handleFullscreenClick}
              className="modal-icon"
            />
            {restProps.closable && (
              <FontAwesomeIcon
                icon={faXmark}
                data-e2e="modal-close-icon"
                className="modal-icon fullscreen-modal-close-icon"
                onClick={onClose}
              />
            )}
          </div>
        </div>
      );
    };

    return (
      <Modal
        {...restProps}
        width={state.fullscreen ? "100vw" : restProps.width}
        centered={state.fullscreen ? false : restProps.centered}
        closable={false}
        style={{
          ...(state.fullscreen
            ? {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflowY: "scroll",
              }
            : {}),
        }}
        // styles={{
        //   body: state.fullscreen
        //     ? {
        //         display: "flex",
        //         flexDirection: "column",
        //         height: "0",
        //         flex: "1",
        //         overflowY: "scroll",
        //         ..._.omit(restProps.styles, ["maxHeight"]),
        //       }
        //     : restProps.styles,
        // }}
        className={state.fullscreen ? "fullscreen-modal enabled" : "fullscreen-modal"}
        title={restProps.title ? renderTitle() : ""}
      >
        {!restProps.title && (
          <div style={{ marginLeft: "auto", marginBottom: "5px", height: "30px" }}>{renderIcons()}</div>
        )}
        {restProps.children}
      </Modal>
    );
  }
);
export { FullscreenModal };
